<template>
  <BittsTooltip
    class="min-w-0 max-w-full"
    :mount-to-body="true"
    default-slot-classes="block min-w-0"
    :is-trigger-focusable="isOverflowing"
    :show-tooltip="isOverflowing ? null : false"
  >
    <span ref="textRef" class="overflow-tooltip__text" :class="textClass">
      {{ text }}
    </span>
    <template #title>{{ text }}</template>
  </BittsTooltip>
</template>

<script setup lang="ts">
import { BittsTooltip } from '@crossbeam/bitts';

import { ref } from 'vue';

import { useIsOverflowing } from '@/composables/useIsOverflowing';

const { text, textClass } = defineProps<{
  text: string;
  textClass?: string;
}>();

const textRef = ref<HTMLElement | null>(null);
const { isOverflowing } = useIsOverflowing(textRef, () => text);
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";
.overflow-tooltip__text {
  @apply block truncate;
}
</style>
